module.exports = __webpack_public_path__ + "static/img/smt_material_20230913.d63dc732.png";